import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { notificationActions } from 'redux/notification/notification.slice';
import { initialDataRackListGetResponseValue } from 'redux/initial-state';
import { DataRackListGetRequest, DataRackListGetResponse } from 'types/entity-ddms';
import { fetchDataRack } from 'api/data-rack.service';

export const DATA_RACK_READ_STORE_NAME = 'dataRackRead';

export const loadDataRack = createAsyncThunk(
  `${DATA_RACK_READ_STORE_NAME}/load`,
  async (payload: { dataRackListGetRequest: DataRackListGetRequest, rackName: string }, thunkAPI) => {
    const { dataRackListGetRequest, rackName } = payload;
    const response = await fetchDataRack(dataRackListGetRequest)
      .catch((error) => {
        thunkAPI.dispatch(notificationActions.addWarning({ messageId: 'dataRackSearch.error', values: [rackName] }));
        throw new Error(error);
      });
    if (response.data_racks?.length === 0) {
      thunkAPI.dispatch(notificationActions.addWarning({ messageId: 'dataRackSearch.error', values: [rackName] }));
    }
    return response;
  },
);

export type DataRackReadState = {
  entity: DataRackListGetResponse
  error: any,
  loadingMap: {[dataRackId: string]: boolean}
}

export const initialDataRackListGetResponseState: DataRackReadState = {
  entity: initialDataRackListGetResponseValue,
  error: null,
  loadingMap: {},
};

export const dataRackReadSlice = createSlice({
  name: DATA_RACK_READ_STORE_NAME,
  initialState: initialDataRackListGetResponseState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadDataRack.pending, (state, action) => {
      state.loadingMap[action.meta.requestId] = true;
    });
    builder.addCase(loadDataRack.fulfilled, (state, action) => {
      state.entity = action.payload;
      delete state.loadingMap[action.meta.requestId];
    });
    builder.addCase(loadDataRack.rejected, (state, action) => {
      state.error = action.payload;
      delete state.loadingMap[action.meta.requestId];
    });
  },
});

export const dataRackReadAction = {
  ...dataRackReadSlice.actions,
  loadDataRack,
};

export default dataRackReadSlice.reducer;
